export const hideGenderIcon = {
  id: 'product-card-icons',
  inputs: {
    showGenderIcon: false,
  },
};
